import React, { useState } from "react";
import { useNavigate } from "react-router-dom";
import * as Icons from "lucide-react";
import { cadaCuantoTitulo } from "@/lib/recordatorios";
import { faltaTxt } from "@/lib/inicio";
import { EstadoEtiqueta } from "@/pages/Gestiones";
import { Etiqueta } from "@/components/inicio/NecesitaAtencion";

const fila = "w-full text-left bg-white border border-[#E5DFD5] rounded-2xl px-4 py-3 flex items-center gap-3 hover:border-[#3A6B56]";
const ICONO = { matter: Icons.FolderOpen, cita: Icons.Stethoscope, recordatorio: Icons.Bell, seguimiento: Icons.Bell, periodico: Icons.Repeat };
const GRUPOS = [
  ["atrasados", "Atrasados", "#B91C1C"], ["hoy", "Para hoy", "#B45309"],
  ["atencion", "Necesitan atención", "#B91C1C"], ["proximos", "Próximos", "#3A6B56"],
];

const Fila = ({ x, proximo }) => {
  const navigate = useNavigate();
  const I = ICONO[x.kind] || Icons.Bell;
  return (
    <button data-testid={`persona-agenda-${x.id}`} onClick={() => navigate(x.ruta)} className={fila}>
      <I size={20} className="text-[#3A6B56] shrink-0" />
      <span className="flex-1 min-w-0 space-y-0.5">
        <span className="block text-base font-semibold text-[#1C2421]">{x.titulo}</span>
        {(x.linea || x.sub) && <span className="block text-sm text-[#4A5550]">{x.linea || x.sub}</span>}
        {proximo ? <span className="block text-base font-bold text-[#3A6B56]">{faltaTxt(x.fecha)}{x.hora ? ` a las ${x.hora}` : ""}</span> : <Etiqueta t={x.etiqueta} />}
      </span>
      <Icons.ChevronRight size={18} className="text-[#6E7A74] shrink-0" />
    </button>
  );
};

export const AgendaPersona = ({ grupos }) => (
  <div className="space-y-4">
    {GRUPOS.filter(([k]) => grupos[k].length).map(([k, label, color]) => (
      <div key={k} className="space-y-2" data-testid={`persona-grupo-${k}`}>
        <h3 className="text-base font-bold" style={{ color }}>{label} ({grupos[k].length})</h3>
        {grupos[k].map((x) => <Fila key={x.id} x={x} proximo={k === "proximos"} />)}
      </div>
    ))}
  </div>
);

export const AnterioresPersona = ({ gestiones }) => {
  const navigate = useNavigate();
  const [abierto, setAbierto] = useState(false);
  if (!gestiones.length) return null;
  return (
    <section className="space-y-3" data-testid="persona-anteriores">
      <h2 className="font-heading text-xl font-bold text-[#1C2421] flex items-center gap-2"><Icons.History size={22} className="text-[#3A6B56]" /> Actividad anterior</h2>
      <button data-testid="persona-anteriores-toggle" aria-expanded={abierto} onClick={() => setAbierto(!abierto)}
        className="w-full min-h-[52px] rounded-2xl bg-white border border-[#D6CFC2] text-[#1C2421] font-semibold text-lg inline-flex items-center justify-center gap-2">
        {abierto ? "Ocultar" : "Ver"} recordatorios pausados y terminados ({gestiones.length}) <Icons.ChevronDown size={20} className={abierto ? "rotate-180" : ""} />
      </button>
      {abierto && gestiones.map((g) => (
        <button key={g.id} data-testid={`persona-anterior-${g.id}`} onClick={() => navigate(`/gestiones/${g.id}`)} className={fila}>
          <Icons.Repeat size={20} className="text-[#6E7A74] shrink-0" />
          <span className="flex-1 min-w-0"><span className="block text-base font-semibold text-[#1C2421]">{g.titulo}</span><span className="block text-sm text-[#4A5550]">{cadaCuantoTitulo(g)}</span></span>
          <EstadoEtiqueta g={g} testid={`persona-anterior-estado-${g.id}`} />
        </button>
      ))}
    </section>
  );
};
